import React, { useEffect, useState } from 'react';
import { saveAs } from 'file-saver';

import CertificateStyle from '../css/Certificate.module.css'

import { DOCUMENTS, fetchDocument, signedDocumentUrl } from '../services/documents';

// The Nagra certificate, which every client may read from the header.
//
// It came from a public Google Drive file until 2026-09-28: anyone with the
// link could read it, it lived outside the three repositories and outside the
// GCP project, and whoever held that Drive could move or delete it without
// anything here noticing (back-ratings' handoff of that day, which found the
// copy in the bucket while tidying reportes/). It is now the same document,
// signed by the back like the templates and the guide.
//
// The URL lives fifteen minutes, so it is asked for when the dialog opens
// rather than when the portal loads.
function Certificate(props) {
    const { open, onClose, accessToken, setAccessToken, getAccessTokenWithRefresh, setMessage, setSeverity, setShowAlert } = props;
    const session = { accessToken, setAccessToken, getAccessTokenWithRefresh };

    const [url, setUrl] = useState('');

    const failed = () => {
        setMessage("No fue posible cargar el certificado. Intente de nuevo más tarde.");
        setSeverity("danger");
        setTimeout(() => { setShowAlert(true) }, 0);
    };

    useEffect(() => {
        if (!open) return;
        let current = true;
        signedDocumentUrl(DOCUMENTS.certificate, session).then((signed) => {
            if (!current) return;
            if (!signed) {
                failed();
                return;
            }
            // Only the page, as Drive's own preview showed it: no toolbar and
            // no panel of thumbnails, and the sheet fitted to the width.
            // These are the Chromium PDF viewer's parameters; Firefox and
            // Safari ignore some of them and draw their own furniture.
            setUrl(`${signed}#toolbar=0&navpanes=0&view=FitH`);
        });
        return () => { current = false; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    const download = async () => {
        const saved = await fetchDocument(DOCUMENTS.certificate, saveAs, session);
        if (!saved) {
            setMessage("No fue posible descargar el certificado. Intente de nuevo más tarde.");
            setSeverity("danger");
            setTimeout(() => { setShowAlert(true) }, 0);
        }
    };

    return (
        <>
            <div className={`${CertificateStyle["certificate"]} ${CertificateStyle[open ? "show-certificate" : "hide-certificate"]}`} id="certificate">
                <div className={CertificateStyle["layer-hide-menu"]} onClick={() => onClose()}></div>
                <div className={CertificateStyle["certificate-container"]} id="certificate-container">
                    <div className={CertificateStyle["certificate-body"]}>
                        {url ? <iframe title="Certificado" className={CertificateStyle["certificate-pdf"]} src={url}></iframe> : null}
                    </div>
                    <div className={CertificateStyle["certificate-button-container"]}>
                        <button className={CertificateStyle["certificate-button-cancel"]} onClick={() => onClose()}>CERRAR</button>
                        <button id="certificate-download" className={CertificateStyle["certificate-button-download"]} onClick={() => download()}>DESCARGAR</button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Certificate;
